module.exports = __webpack_public_path__ + "static/img/nc_mit_xfoce_prime_2025.7a3a445.jpg";